import { render, staticRenderFns } from "./SpendingDecisions.vue?vue&type=template&id=377d2c4a&scoped=true&lang=pug"
import script from "./SpendingDecisions.vue?vue&type=script&lang=ts"
export * from "./SpendingDecisions.vue?vue&type=script&lang=ts"
import style0 from "./SpendingDecisions.vue?vue&type=style&index=0&id=377d2c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d2c4a",
  null
  
)

export default component.exports